export const STATSIG_EVENT_NAMES = {
    CHECKOUT_ALL_ABANDON_ORDER_CLICK: 'Checkout - All - Click - Abandon Order',
    CHECKOUT_ALL_SUCCESS_ABANDON_ORDER:
        'Checkout - All - Sucsess - Abandon Order',
    CHECKOUT_STEP_END_CHECKOUT_FORM_VIEW:
        'Checkout - Checkout Step - View - End Checkout Form',
    CHECKOUT_STEP_ORDER_SUCCESS:
        'Checkout - Checkout Step - Success - Place Order',
    CHECKOUT_STEP_PAGE_VIEW: 'Checkout - Checkout Step - View - Page',
    CHECKOUT_STEP_PAYMENT_SELECTION_CLICK:
        'Checkout - Checkout Step - Click - Payment Selection',
    CHECKOUT_STEP_PLACE_ORDER_CLICK:
        'Checkout - Checkout Step - Click - Place Order',
    CHECKOUT_STEP_TRUST_MESSAGE_VIEW:
        'Checkout - Checkout Step - View - Trust Message',
    LOGIN_STEP_PAGE_VIEW: 'Checkout - Login Step - View - Page',
    LOGIN_STEP_SUCCESS_LOGIN: 'Checkout - Login Step - Success - Button Login',
};

export enum TrustMessageText {
    NO_MESSAGE = 'no_message',
    VARIANT_TRANSACTION_SAFE = 'transactions_safe',
    VARIANT_PEOPLE_SECURELY_ORDER = 'people_securely_order',
}

export const TRUST_MESSAGE_EXPERIMENT = {
    defaultValue: TrustMessageText.NO_MESSAGE,
    name: 'checkout_trust_message',
    param: 'trust_message_copy',
};
